import { useTranslation as useI18nTranslation } from 'react-i18next'

export function useTranslation() {
  return useI18nTranslation()
}

// Export the hook for convenience
export { useTranslation as useT }
